import React, { useEffect, useState } from 'react';
import { Button } from 'components/_shared/Button';
import { useBulkApproveMutation } from 'state';
import { Bar, Hint, Controls, SizeInput, Result, ErrorText } from './BulkBar.styles';

const errorText = error =>
  typeof error?.data === 'string' ? error.data : 'The request failed.';

export const BulkBar = ({ field, onApproved }) => {
  const [bulkApprove, { isLoading }] = useBulkApproveMutation();
  const [minSize, setMinSize] = useState('');
  const [matched, setMatched] = useState(null);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setMatched(null);
    setMessage(null);
    setError(null);
  }, [field?.id, minSize]);

  if (!field) {
    return <Hint>Click a field name to approve its pending stones in bulk.</Hint>;
  }

  const size = Number(minSize);
  const isValid = minSize !== '' && size > 0;

  const run = async dryRun => {
    setError(null);
    try {
      const result = await bulkApprove({
        field_id: field.id,
        min_size_cm: size,
        dry_run: dryRun
      }).unwrap();
      if (dryRun) {
        setMatched(result.matched);
      } else {
        setMatched(null);
        setMessage(`Approved ${result.approved}.`);
        onApproved?.(result.approved);
      }
    } catch (e) {
      setError(errorText(e));
    }
  };

  return (
    <Bar data-testid='bulk-bar'>
      <b>Approve in bulk: {field.name}</b>
      <Controls>
        <span>Pending stones at or above</span>
        <SizeInput
          type='number'
          min='0'
          step='any'
          value={minSize}
          onChange={e => setMinSize(e.target.value)}
        />
        <span>cm</span>
        <Button disabled={!isValid || isLoading} onClick={() => run(true)}>
          Count
        </Button>
        {matched != null && (
          <Button
            variant='primary'
            disabled={matched === 0 || isLoading}
            onClick={() => run(false)}
          >
            Approve {matched}
          </Button>
        )}
      </Controls>
      <Hint>
        Stones without a size are never included. Only the open survey is touched.
      </Hint>
      {message && <Result>{message}</Result>}
      {error && <ErrorText>{error}</ErrorText>}
    </Bar>
  );
};
